import React from "react";
import EmployeeDashboard from "../components/EmployeeDashboard";

function Employee() {
  return (
    <div className="">
      <EmployeeDashboard />
    </div>
  );
}

export default Employee;
